import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'font-(family-name:--font-gotham)',
    content: 'relative',
    navigation:
      'max-lg:scrollbar-hidden fixed right-0 bottom-2 left-0 z-10 mx-auto transition-transform duration-500 ease-out max-lg:overflow-x-scroll md:flex md:justify-center lg:top-[670px] lg:bottom-auto',
    disclaimer:
      'z-1 mx-auto mt-12 flex max-w-[1400px] flex-col gap-2 px-3 text-[#747D81] lg:my-10 lg:mb-16 lg:px-[68px]',
    disclaimerText: 'max-w-[800px] text-[12px] leading-[1.36]',
    resultsAndQuote: 'relative',
    results: 'relative z-1',
    quote: 'relative z-1',
    cap: 'absolute top-35 right-0 z-0 lg:-top-70 lg:right-auto lg:left-0',
    bg: 'absolute top-0 left-0 z-0 h-auto w-full lg:-top-160',
    products: 'relative z-1',
    bottom: 'relative z-1',
    statistic: 'relative z-1',
    help: 'relative z-1',
    wards: 'relative z-1'
  },
  variants: {
    isScrolled: {
      true: {
        navigation: 'lg:translate-y-[calc(100vh-670px-70px)]'
      },
      false: {
        navigation: 'lg:translate-y-0'
      }
    },
    isNearFooter: {
      true: {
        navigation: 'pointer-events-none opacity-0'
      },
      false: {
        navigation: 'opacity-100'
      }
    }
  }
});
